import { inject, Service } from '@angular/core';
import { MgsWebApi } from '../../mgs-webapi.service';
import { firstValueFrom } from 'rxjs';
import { IBatchInProgressInfo, IKidsImportInfo } from '@mng/mgs-lib';

@Service()
export class KidsImportService {
  readonly webApi = inject(MgsWebApi);

  async kidsDatenImportStarten(file: File, importInfo: IKidsImportInfo, asyncImport = true) {
    return firstValueFrom(this.webApi.kidsDatenImportStarten(file, importInfo, asyncImport));
  }

  async kidsImportInfoErmitteln(): Promise<IBatchInProgressInfo> {
    return firstValueFrom(this.webApi.kidsImportInProgressInfo());
  }
}
